import React from 'react';
import './index.css';

const FingerPrint = ({ color, size, selected, onSelected }) => {

  const handleClick = () => {
    onSelected && onSelected();
  };

  return (
    <div
      className={`fingerprint-container ${selected ? 'selected' : ''}`}
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <div
        className="fingerprint"
        style={{
          borderColor: color,
        }}
      ></div>
    </div>
  );
};

export default FingerPrint;
